module.exports = __webpack_public_path__ + "static/media/header-metalicos.55f6b453.png";